export type MapPinVariant =
  | 'opportunity'
  | 'lead'
  | 'pendinglead'
  | 'draftlead'
  | 'mixed'
  | 'pestpaclocation'
  | 'current_location'
  | 'knockstatus'
  | 'DoNotKnock'

export enum MapPinTypeVariant {
  Opportunity = 'opportunity',
  Lead = 'lead',
  PendingLead = 'pendinglead',
  DraftLead = 'draftlead',
  Mixed = 'mixed',
  PestPac = 'pestpaclocation',
  CurrentLocation = 'current_location',
  KnockStatus = 'knockstatus',
  DoNotKnock = 'DoNotKnock',
}

export type KnockStatusProps = {
  id: number
  name: string
  isSystem: boolean
  displayOrder: number
  color: string
  icon: number
} | null

export type MapPinProps = {
  variant: MapPinVariant
  count?: number
  knockStatus: KnockStatusProps
}
